import { Component } from '@angular/core';
import { LaunchService } from './launch.service';
import { Router, NavigationStart } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  configData: any = {};

  constructor(private launchService: LaunchService, private router: Router) {
    router.events.subscribe(event => {
      if (event instanceof NavigationStart && event.id > 1 && event.url === '/') {
        if (localStorage) {
          localStorage.removeItem('selected-region');
        }
      }
    });

  }

  ngOnInit() {
    this.launchService.getConfig().then(data => {
      this.configData = data;
      if (localStorage) {
        var prevSelectedRegion = localStorage.getItem('selected-region');
        if (prevSelectedRegion) {
          this.router.navigate(['', prevSelectedRegion]);
        }
      }
    });
  }
}
